export default __webpack_public_path__ + "static/media/misc-closetC-480w.f6ea80e6.avif";